// document.addEventListener("DOMContentLoaded", (event) => {
//     var storageKey = "smokeAlarmCalculatorResult";

//     function getNumberValue(selector) {
//         return parseInt($(selector).val()) || 0;
//     }

//     function buildCalculatorResultData() {
//         var step1 = getNumberValue("#step-1");
//         var step3 = getNumberValue("#step-3");
//         var areBedroomsUsingSameHallway = $("#step-2").is(":checked");
//         var step2 = areBedroomsUsingSameHallway ? 1 : step3;
//         var step5 = getNumberValue("#step-5");
//         var areBedroomsConnectedToOpenSpaces = $("#step-4").is(":checked");
//         var step4 = areBedroomsConnectedToOpenSpaces ? step5 : 0;
//         var step6 = getNumberValue("#step-6");
//         var step7 = getNumberValue("#step-7");
//         var totalForStep1 = step1;
//         var totalForStep2 = step2;
//         var totalForStep4 = step4 > 0 ? step4 : 0;
//         var totalForStep6 = 0;
//         var resultItems = [];
//         var reviewItems = [];

//         if(step6 > 1){
//             totalForStep6 = step6 - step7;
//         }

//         var total = totalForStep1 + totalForStep2 + totalForStep4 + totalForStep6;

//         resultItems.push(`A minimum of ${total} smoke alarms will be required in your home to meet the Queensland requirements.`);
//         resultItems.push(`The ${step1} bedrooms require ${step1} smoke alarm.`);

//         if(step2 > 1){
//             resultItems.push(`The ${step2} hallway connecting your bedrooms will require ${step2} smoke alarm in each.`);
//         }else{
//             resultItems.push(`The ${step2} hallway connecting your bedrooms will require ${step2} smoke alarm.`);
//         }

//         if(step4 > 0){
//             resultItems.push(`The ${step4} Living area's, rumpus rooms or open spaces that connect to bedrooms will require one smoke alarm in each.`);
//         }

//         if(step6 > 1){
//             resultItems.push("The level without bedrooms will require one smoke alarm on the most likely path of exit.");
//         }

//         if(step1 > 0){
//             reviewItems.push({
//                 question: "How many bedrooms are in your home?",
//                 answer: step1
//             });
//         }

//         if(areBedroomsUsingSameHallway){
//             reviewItems.push({
//                 question: "Do all the bedrooms in your home use the same hallway?",
//                 answer: "yes"
//             });
//         }else{
//             reviewItems.push({
//                 question: "Do all the bedrooms in your home use the same hallway?",
//                 answer: "no"
//             });

//             if(step2 >= 1){
//                 reviewItems.push({
//                     question: "How many hallways have connecting bedrooms?",
//                     answer: step2
//                 });
//             }
//         }

//         if(step4 > 0){
//             reviewItems.push({
//                 question: "Do any bedrooms connect to open spaces (e.g dining room, living room, open are)?",
//                 answer: "yes"
//             });
//             reviewItems.push({
//                 question: "How many open spaces connect to your bedrooms and hallways?",
//                 answer: step4
//             });
//         }else{
//             reviewItems.push({
//                 question: "Do any bedrooms connect to open spaces (e.g dining room, living room, open are)?",
//                 answer: "no"
//             });
//         }

//         if(step6 > 0){
//             reviewItems.push({
//                 question: "How many floors in your home?",
//                 answer: step6
//             });
//         }

//         if(step7 > 0){
//             reviewItems.push({
//                 question: "How many floors have bedrooms on them?",
//                 answer: step7
//             });
//         }

//         return {
//             total: total,
//             resultItems: resultItems,
//             reviewItems: reviewItems
//         };
//     }

//     function renderCalculatorResult(data) {
//         $("#pack-of-needed").html(data.total);
//         $(".total-qunatity").html(data.total);
//         $("#result-list").empty();
//         $("#review-answers").empty();

//         data.resultItems.forEach(function(item) {
//             $("#result-list").append($("<li>").text(item));
//         });

//         data.reviewItems.forEach(function(item) {
//             var reviewItem = $("<div>");
//             reviewItem.append($("<h4>").text(item.question));
//             reviewItem.append($("<p>").text("Your answer: ").append($("<span>").text(item.answer)));
//             $("#review-answers").append(reviewItem);
//         });

//         var cardImage = $("#card img");
//         var cardAddToCart = $("#card a.m-button");
//         var packOfNeededWrapper = $("#pack-of-needed-wrapper");

//         if (window.saQuantityProducts && window.saQuantityProducts[data.total]) {
//             var prod = window.saQuantityProducts[data.total];
//             if (cardImage.length) cardImage.attr("src", prod.image);
//             if (packOfNeededWrapper.length) packOfNeededWrapper.hide();
            
//             cardAddToCart.attr("href", prod.url);
//             if (cardAddToCart.attr("onclick")) {
//                 cardAddToCart.attr("onclick", "event.preventDefault(); window.location.href = '/cart/add?id=" + prod.variant_id + "&quantity=1';");
//             }
//         } else {
//             if (window.saDefaultProduct) {
//                 if (cardImage.length) cardImage.attr("src", window.saDefaultProduct.image);
//                 cardAddToCart.attr("href", window.saDefaultProduct.url);
//                 if (cardAddToCart.attr("onclick")) {
//                     cardAddToCart.attr("onclick", "event.preventDefault(); window.location.href = '/cart/add?id=" + window.saDefaultProduct.variant_id + "&quantity=" + data.total + "';");
//                 }
//             }
//             if (packOfNeededWrapper.length) packOfNeededWrapper.show();
//         }

//         $("#result").fadeIn(10);
//     }

//     $("#sac-start-btn").click(function(){
//         $("#sac-begin").css({"display":"none"});
//         $("#sac-step-1").css({"display":"flex"});
//     }); 

//     // back buttons start
//     $(".back-button").click(function(){
//         var currentStep = $(this).attr("data-step-current");
//         var prevStep = $(this).attr("data-step-prev");

//         $(currentStep).css({"display": "none"});
//         $(prevStep).css({"display": "flex"});
//     });
//     // back buttons end

//     // field input check start
//     function updateValue(operation) {
//         var field_value = $(this).siblings(".field-input").val();
//         field_value = parseInt(field_value) || 0;

//         // Check for the "minus" operation and ensure the value doesn't go below 0
//         if (operation === 'minus') {
//             if (field_value > 0) {
//                 field_value -= 1;
//             } else {
//                 // Show error if value is already 0
//                 $(".error").addClass("active");
//                 return; // Stop execution if trying to decrement below 0
//             }
//         } else if (operation === 'plus') {
//             field_value += 1;
//             // Remove the error when value is increased above 0
//             $(".error").removeClass("active");
//         }

//         $(this).siblings(".field-input").val(field_value);
//         $(this).siblings(".field-display").empty().html(field_value);
//     }

//     // Event listeners for the buttons
//     $(".minus-button").click(function() {
//         updateValue.call(this, 'minus');
//     });

//     $(".plus-button").click(function() {
//         updateValue.call(this, 'plus');
//     });
//     // field input check end

//     // field type 2 check start
//     $(".yes-button").click(function(){
//         $(this).siblings("input").attr('checked', true);

//         var nextStep = $(this).siblings("input").attr("data-next-step");
//         var currentStep = $(this).siblings("input").attr("data-current-step");

//         // $(currentStep).css({"display": "none"});
//         // $(nextStep).css({"display": "flex"});

//         if(currentStep == "#sac-step-2"){
//             $(currentStep).css({"display": "none"});
//             $("#sac-step-4").css({"display": "flex"});
//         }else{
//             $(currentStep).css({"display": "none"});
//             $(nextStep).css({"display": "flex"});
//         }
//     });
//     $(".no-button").click(function(){
//         $(this).siblings("input").attr('checked', false);

//         var nextStep = $(this).siblings("input").attr("data-next-step");
//         var currentStep = $(this).siblings("input").attr("data-current-step");

//         // $(currentStep).css({"display": "none"});
//         // $(nextStep).css({"display": "flex"});

//         if(currentStep == "#sac-step-4"){
//             $(currentStep).css({"display": "none"});
//             $(nextStep).css({"display": "none"});
//             $("#sac-step-6").css({"display": "flex"});
//         }else{
//             $(currentStep).css({"display": "none"});
//             $(nextStep).css({"display": "flex"});
//         }
//     });
//     // field type 2 check end

//     // next button start
//     $(".next-button").click(function(){
//         var stepData = $(this).parent().siblings(".field-input").val();
//         var nextStep = $(this).attr("data-next-step");
//         var currentStep = $(this).attr("data-current-step");

//         stepData = parseInt(stepData);

//         if(currentStep == "#sac-step-3"){
//             if(stepData >= 1){
//                 $(nextStep).css({"display": "flex"});
//                 $(currentStep).css({"display": "none"});
//             }else{
//                 $("#sac-final").css({"display": "flex"});
//                 $(currentStep).css({"display": "none"});
//             }
//         }else if(currentStep == "#sac-step-6"){
//             if(stepData > 1){
//                 $(nextStep).css({"display": "flex"});
//                 $(currentStep).css({"display": "none"});
//             }else{
//                 $("#sac-final").css({"display": "flex"});
//                 $(currentStep).css({"display": "none"});
//             }
//         }else{
//             if(stepData >= 0){
//                 $(nextStep).css({"display": "flex"});
//                 $(currentStep).css({"display": "none"});
//             }
//         }
//     });

//     // toggles start
//     $(".terms-open-button").click(function(){
//         $(".sac-final-info").fadeToggle(300);
//     });
//     $(".review-answers-button").click(function(){
//         $("#review-answers-wrapper").fadeToggle(200);
//     });
//     $("#install-hard-wired-button").click(function(){
//         $("#install-hard-wired-content").fadeToggle(200);
//     });
//     // toggles end
//     // next button end

//     // get result start
//     $("#sac-end-btn").click(function(){
//         if($("#terms-and-conditions").is(":checked")){
//             $("#sac-final").css({"display": "none"});
//             var resultData = buildCalculatorResultData();
//             var resultPageUrl = $("#smoke-alarm-calculator").attr("data-result-url") || "/pages/result";

//             try {
//                 sessionStorage.setItem(storageKey, JSON.stringify(resultData));
//                 window.location.href = resultPageUrl;
//             } catch (error) {
//                 renderCalculatorResult(resultData);
//             }
//         }else{
//             $(this).siblings(".error").addClass("active");
//         }
//     });
//     // get result end

//     // form reset
//     $("#reset-button").click(function(){
//         window.location.reload();
//     });
// });



document.addEventListener("DOMContentLoaded", (event) => {
    var storageKey = "smokeAlarmCalculatorResult";

    function getNumberValue(selector) {
        return parseInt($(selector).val()) || 0;
    }

    function buildCalculatorResultData() {
        var step1 = getNumberValue("#step-1");
        var step3 = getNumberValue("#step-3");
        var areBedroomsUsingSameHallway = $("#step-2").is(":checked");
        var step2 = areBedroomsUsingSameHallway ? 1 : step3;
        var step5 = getNumberValue("#step-5");
        var areBedroomsConnectedToOpenSpaces = $("#step-4").is(":checked");
        var step4 = areBedroomsConnectedToOpenSpaces ? step5 : 0;
        var step6 = getNumberValue("#step-6");
        var step7 = getNumberValue("#step-7");
        var totalForStep1 = step1;
        var totalForStep2 = step2;
        var totalForStep4 = step4 > 0 ? step4 : 0;
        var totalForStep6 = 0;
        var resultItems = [];
        var reviewItems = [];

        if(step6 > 1){
            totalForStep6 = step6 - step7;
        }

        var total = totalForStep1 + totalForStep2 + totalForStep4 + totalForStep6;

        resultItems.push(`A minimum of ${total} smoke alarms will be required in your home to meet the Queensland requirements.`);
        resultItems.push(`The ${step1} bedrooms require ${step1} smoke alarm.`);

        if(step2 > 1){
            resultItems.push(`The ${step2} hallway connecting your bedrooms will require ${step2} smoke alarm in each.`);
        }else{
            resultItems.push(`The ${step2} hallway connecting your bedrooms will require ${step2} smoke alarm.`);
        }

        if(step4 > 0){
            resultItems.push(`The ${step4} Living area's, rumpus rooms or open spaces that connect to bedrooms will require one smoke alarm in each.`);
        }

        if(step6 > 1){
            resultItems.push("The level without bedrooms will require one smoke alarm on the most likely path of exit.");
        }

        if(step1 > 0){
            reviewItems.push({
                question: "How many bedrooms are in your home?",
                answer: step1
            });
        }

        if(areBedroomsUsingSameHallway){
            reviewItems.push({
                question: "Do all the bedrooms in your home use the same hallway?",
                answer: "yes"
            });
        }else{
            reviewItems.push({
                question: "Do all the bedrooms in your home use the same hallway?",
                answer: "no"
            });

            if(step2 >= 1){
                reviewItems.push({
                    question: "How many hallways have connecting bedrooms?",
                    answer: step2
                });
            }
        }

        if(step4 > 0){
            reviewItems.push({
                question: "Do any bedrooms connect to open spaces (e.g dining room, living room, open are)?",
                answer: "yes"
            });
            reviewItems.push({
                question: "How many open spaces connect to your bedrooms and hallways?",
                answer: step4
            });
        }else{
            reviewItems.push({
                question: "Do any bedrooms connect to open spaces (e.g dining room, living room, open are)?",
                answer: "no"
            });
        }

        if(step6 > 0){
            reviewItems.push({
                question: "How many floors in your home?",
                answer: step6
            });
        }

        if(step7 > 0){
            reviewItems.push({
                question: "How many floors have bedrooms on them?",
                answer: step7
            });
        }

        return {
            total: total,
            resultItems: resultItems,
            reviewItems: reviewItems
        };
    }

    function renderCalculatorResult(data) {
        $("#pack-of-needed").html(data.total);
        $(".total-qunatity").html(data.total);
        $("#result-list").empty();
        $("#review-answers").empty();

        data.resultItems.forEach(function(item) {
            $("#result-list").append($("<li>").text(item));
        });

        data.reviewItems.forEach(function(item) {
            var reviewItem = $("<div>");
            reviewItem.append($("<h4>").text(item.question));
            reviewItem.append($("<p>").text("Your answer: ").append($("<span>").text(item.answer)));
            $("#review-answers").append(reviewItem);
        });

        var cardImage = $("#card img");
        var cardAddToCart = $("#card a.m-button");
        var packOfNeededWrapper = $("#pack-of-needed-wrapper");

        if (window.saQuantityProducts && window.saQuantityProducts[data.total]) {
            var prod = window.saQuantityProducts[data.total];
            if (cardImage.length) cardImage.attr("src", prod.image);
            if (packOfNeededWrapper.length) packOfNeededWrapper.hide();
            
            cardAddToCart.attr("href", prod.url);
            if (cardAddToCart.attr("onclick")) {
                cardAddToCart.attr("onclick", "event.preventDefault(); window.location.href = '/cart/add?id=" + prod.variant_id + "&quantity=1';");
            }
        } else {
            if (window.saDefaultProduct) {
                if (cardImage.length) cardImage.attr("src", window.saDefaultProduct.image);
                cardAddToCart.attr("href", window.saDefaultProduct.url);
                if (cardAddToCart.attr("onclick")) {
                    cardAddToCart.attr("onclick", "event.preventDefault(); window.location.href = '/cart/add?id=" + window.saDefaultProduct.variant_id + "&quantity=" + data.total + "';");
                }
            }
            if (packOfNeededWrapper.length) packOfNeededWrapper.show();
        }

        $("#result").fadeIn(10);
    }

    $("#sac-start-btn").click(function(){
        $("#sac-begin").css({"display":"none"});
        $("#sac-step-1").css({"display":"flex"});
    }); 

    // back buttons start
    $(".back-button").click(function(){
        var currentStep = $(this).attr("data-step-current");
        var prevStep = $(this).attr("data-step-prev");

        $(currentStep).css({"display": "none"});
        $(prevStep).css({"display": "flex"});
    });
    // back buttons end

    // field input check start
    function updateValue(operation) {
        var field_value = $(this).siblings(".field-input").val();
        field_value = parseInt(field_value) || 0;

        // Check for the "minus" operation and ensure the value doesn't go below 0
        if (operation === 'minus') {
            if (field_value > 0) {
                field_value -= 1;
            } else {
                // Show error if value is already 0
                $(".error").addClass("active");
                return; // Stop execution if trying to decrement below 0
            }
        } else if (operation === 'plus') {
            field_value += 1;
            // Remove the error when value is increased above 0
            $(".error").removeClass("active");
        }

        $(this).siblings(".field-input").val(field_value);
        $(this).siblings(".field-display").empty().html(field_value);
    }

    // Event listeners for the buttons
    $(".minus-button").click(function() {
        updateValue.call(this, 'minus');
    });

    $(".plus-button").click(function() {
        updateValue.call(this, 'plus');
    });
    // field input check end

    // field type 2 check start
    $(".yes-button").click(function(){
        $(this).siblings("input").attr('checked', true);

        var nextStep = $(this).siblings("input").attr("data-next-step");
        var currentStep = $(this).siblings("input").attr("data-current-step");

        // $(currentStep).css({"display": "none"});
        // $(nextStep).css({"display": "flex"});

        if(currentStep == "#sac-step-2"){
            $(currentStep).css({"display": "none"});
            $("#sac-step-4").css({"display": "flex"});
        }else{
            $(currentStep).css({"display": "none"});
            $(nextStep).css({"display": "flex"});
        }
    });
    $(".no-button").click(function(){
        $(this).siblings("input").attr('checked', false);

        var nextStep = $(this).siblings("input").attr("data-next-step");
        var currentStep = $(this).siblings("input").attr("data-current-step");

        // $(currentStep).css({"display": "none"});
        // $(nextStep).css({"display": "flex"});

        if(currentStep == "#sac-step-4"){
            $(currentStep).css({"display": "none"});
            $(nextStep).css({"display": "none"});
            $("#sac-step-6").css({"display": "flex"});
        }else{
            $(currentStep).css({"display": "none"});
            $(nextStep).css({"display": "flex"});
        }
    });
    // field type 2 check end

    // next button start
    $(".next-button").click(function(){
        var stepData = $(this).parent().siblings(".field-input").val();
        var nextStep = $(this).attr("data-next-step");
        var currentStep = $(this).attr("data-current-step");

        stepData = parseInt(stepData);

        if(currentStep == "#sac-step-3"){
            if(stepData >= 1){
                $(nextStep).css({"display": "flex"});
                $(currentStep).css({"display": "none"});
            }else{
                $("#sac-final").css({"display": "flex"});
                $(currentStep).css({"display": "none"});
            }
        }else if(currentStep == "#sac-step-6"){
            if(stepData > 1){
                $(nextStep).css({"display": "flex"});
                $(currentStep).css({"display": "none"});
            }else{
                $("#sac-final").css({"display": "flex"});
                $(currentStep).css({"display": "none"});
            }
        }else{
            if(stepData >= 0){
                $(nextStep).css({"display": "flex"});
                $(currentStep).css({"display": "none"});
            }
        }
    });

    // toggles start
    $(".terms-open-button").click(function(){
        $(".sac-final-info").fadeToggle(300);
    });
    $(".review-answers-button").click(function(){
        $("#review-answers-wrapper").fadeToggle(200);
    });
    $("#install-hard-wired-button").click(function(){
        $("#install-hard-wired-content").fadeToggle(200);
    });
    // toggles end
    // next button end

    // horizontal form get result start
    $("#sac-hor-submit").click(function(e){
        e.preventDefault();
        
        var bedrooms = parseInt($("#hor-bedrooms").val()) || 0;
        var storeys = parseInt($("#hor-storeys").val()) || 1;
        var hallways = parseInt($("#hor-hallways").val()) || 0;
        
        var total = bedrooms + hallways + (storeys > 1 ? storeys - 1 : 0);
        
        var resultItems = [];
        var reviewItems = [];
        
        resultItems.push(`A minimum of ${total} smoke alarms will be required in your home to meet the Queensland requirements.`);
        resultItems.push(`The ${bedrooms} bedrooms require ${bedrooms} smoke alarm.`);
        
        if (hallways > 0) {
            resultItems.push(`The ${hallways} hallway connecting your bedrooms will require ${hallways} smoke alarm${hallways > 1 ? ' in each' : ''}.`);
        }
        
        if(storeys > 1){
            resultItems.push("The levels without bedrooms will require one smoke alarm on the most likely path of exit.");
        }
        
        reviewItems.push({ question: "How many bedrooms are in your home?", answer: bedrooms });
        reviewItems.push({ question: "How many floors in your home?", answer: storeys });
        reviewItems.push({ question: "How many hallways have connecting bedrooms?", answer: hallways });
        
        var resultData = {
            total: total,
            resultItems: resultItems,
            reviewItems: reviewItems
        };
        
        var resultPageUrl = $("#smoke-alarm-calculator").attr("data-result-url") || "/pages/result";
        
        try {
            sessionStorage.setItem(storageKey, JSON.stringify(resultData));
            window.location.href = resultPageUrl;
        } catch (error) {
            renderCalculatorResult(resultData);
        }
    });
    // horizontal form get result end

    // get result start
    $("#sac-end-btn").click(function(){
        if($("#terms-and-conditions").is(":checked")){
            $("#sac-final").css({"display": "none"});
            var resultData = buildCalculatorResultData();
            var resultPageUrl = $("#smoke-alarm-calculator").attr("data-result-url") || "/pages/result";

            try {
                sessionStorage.setItem(storageKey, JSON.stringify(resultData));
                window.location.href = resultPageUrl;
            } catch (error) {
                renderCalculatorResult(resultData);
            }
        }else{
            $(this).siblings(".error").addClass("active");
        }
    });
    // get result end

    // form reset
    $("#reset-button").click(function(){
        window.location.reload();
    });

    // --- COMPACT LAYOUT JS ---
    
    // Set default active states for Yes/No buttons
    $('.sac-c-yes[data-target="sac-c-hallway-count-wrap"]').addClass('sac-c-active');
    $('.sac-c-no[data-target="sac-c-open-area-count-wrap"]').addClass('sac-c-active');

    // Handle Yes/No button clicks
    $(".sac-c-btn").click(function() {
        var group = $(this).parent();
        group.find('.sac-c-btn').removeClass('sac-c-active');
        $(this).addClass('sac-c-active');
        
        var targetId = $(this).attr('data-target');
        var action = $(this).attr('data-action');
        
        if (action === 'show') {
            $('#' + targetId).slideDown(200);
        } else {
            $('#' + targetId).slideUp(200);
        }
    });

    // Handle storeys dropdown to conditionally show "Storeys with bedrooms"
    $("#sac-c-storeys").change(function() {
        var storeys = parseInt($(this).val()) || 1;
        if (storeys > 1) {
            $("#sac-c-storeys-with-bedrooms-wrap").slideDown(200);
        } else {
            $("#sac-c-storeys-with-bedrooms-wrap").slideUp(200);
        }
    });

    // Handle Compact Submit
    $("#sac-c-submit").click(function(e) {
        e.preventDefault();
        
        var bedrooms = parseInt($("#sac-c-bedrooms").val()) || 0;
        
        var sameHallway = $('.sac-c-yes[data-target="sac-c-hallway-count-wrap"]').hasClass('sac-c-active');
        var hallways = sameHallway ? 1 : (parseInt($('#sac-c-hallways').val()) || 0);
        
        var hasOpenAreas = $('.sac-c-yes[data-target="sac-c-open-area-count-wrap"]').hasClass('sac-c-active');
        var openAreas = hasOpenAreas ? (parseInt($('#sac-c-open-areas').val()) || 0) : 0;
        
        var storeys = parseInt($("#sac-c-storeys").val()) || 1;
        var storeysWithBed = parseInt($("#sac-c-storeys-bedrooms").val()) || 1;
        
        var extraStoreysAlarms = 0;
        if (storeys > 1) {
            extraStoreysAlarms = storeys - storeysWithBed;
            if (extraStoreysAlarms < 0) extraStoreysAlarms = 0;
        }
        
        var originalTotal = bedrooms + hallways + openAreas + extraStoreysAlarms;
        var recommendedTotal = originalTotal <= 4 ? 5 : originalTotal;
        
        // Render result box inline
        $("#sac-c-result-number").text(originalTotal + " smoke alarms");
        
        var prod = null;
        if (window.saQuantityProducts && window.saQuantityProducts[recommendedTotal]) {
            prod = window.saQuantityProducts[recommendedTotal];
        } else if (window.saDefaultProduct) {
            prod = window.saDefaultProduct;
        }
        
        if (prod) {
            $("#sac-c-result-img").attr("src", prod.image);
            $("#sac-c-result-name").text(prod.title || "EasyFit Home Kit");
            $("#sac-c-result-desc").text(recommendedTotal + " interconnected alarms + FREE test & hush remote");
            
            if (prod.price) {
                $("#sac-c-result-price").text(prod.price).show();
            } else {
                $("#sac-c-result-price").hide();
            }
            
            $("#sac-c-result-btn").text("Choose My " + recommendedTotal + "-Alarm Kit");
            
            var addUrl = "/cart/add?id=" + prod.variant_id + "&quantity=" + (window.saQuantityProducts && window.saQuantityProducts[recommendedTotal] ? 1 : recommendedTotal);
            $("#sac-c-result-btn").attr("href", addUrl);
        }
        
        if (originalTotal <= 4) {
            $("#sac-c-min-alarms").text(originalTotal);
            $("#sac-c-result-info").slideDown(200);
        } else {
            $("#sac-c-result-info").hide();
        }
        
        $("#sac-c-result-box").slideDown(300);
        
        // Scroll down to result box
        $('html, body').animate({
            scrollTop: $("#sac-c-result-box").offset().top - 100
        }, 500);
    });

});
